import * as React from "react"
import { Link } from "gatsby"
import Logo from '../images/logo.png';
import Discord from '../images/discord.png';
import Footer from "../components/Footer";
import { Helmet } from "react-helmet";

// markup
const AboutPage = () => {
  return (
    <main>
        <Helmet>
            <title>Dotastatz - About</title>
            <meta name="description" content="Dotastatz is a fan made application that allows Dota 2 players to find and track their profile easily without logging in. The app will keep you up to date on all the important tournaments, team ranking and many more." />
        </Helmet>
        <div className="content">
            <div className="mobile-container">
                <div className="logo-container mb-4">
                    <img src={Logo} alt="Dotastatz logo" className="w-100 h-100"></img>
                </div>
                
                <h2 className="section-title">What's Dotastatz?</h2>
                <p className="section-body mb-4"> 
                    Dotastatz is a fan-made application that allows Dota 2 players to find and track their profile without logging in. The app will keep you up to date on all the important tournaments, team ranking and many more.
                </p>
                <h2 className="section-title"><span role="img" aria-label="star">⭐</span>  Features</h2>
                <p className="section-body mb-4"> 
                    •  Find and follow your favourite player <br/>
                    •  Unique personal profile for every Dota 2 player<br/>
                    •  In-depth match details and statistics<br/>
                    •  See upcoming tournament schedules<br/>
                    •  Explore the latest team ranking, leaderboard and more<br/>
                </p>
                {/* <h2 className="section-title"><span role="img" aria-label="rocket">🚀</span> Mission</h2>
                <p className="section-body mb-4"> 
                    Coming soon...
                </p> */}
                <h2 className="section-title">😱 What's new?</h2>
                <p className="section-body mb-4"> 
                    Check out this <a href="https://www.notion.so/Dotastatz-What-s-New-fa901168ac7a4da691f29836fa49b288" className="">What's new</a> page.
                </p> 
                <h2 className="section-title"><span role="img" aria-label="future">⚡</span> On-going development (Features)</h2>
                <p className="section-body mb-4"> 
                    •  Search page optimisation <br/>
                    •  Recent activity of followed players <br/>
                    •  More statistics and analysis for player profile and single match <br/>
                    •  League and tournament bracket information <br/>
                    •  New logo <br/>
                </p>
                
                <h2 className="section-title"><span role="img" aria-label="question">🤔</span> Questions</h2>
                <p className="section-body mb-4"> 
                    Please consult our <Link to='/faq/' className="">Frequently Asked Questions</Link>. If you can't find the answers you need, please email us at <a href="mailto:dotastats.app@gmail.com/" className="">dotastats.app@gmail.com</a> or join our discord coummunity server.
                </p>

                <h2 className="section-title"><span role="img" aria-label="community">🤟</span> Community</h2>
                <p className="section-body mb-3"> 
                    Please join us on Discord! I will post new features and bug fixes every month on this discord server. Other than that, you can also report the bugs or request new features in relevant channels.
                </p>
                <div className="mb-4">
                    <a href="https://discord.gg/9TYHnJQf" className="discord-icon">
                        <img src={Discord} alt="discord dotastatz" className="w-100 h-100"/>
                    </a>
                </div>

                <h2 className="section-title"><span role="img" aria-label="me">🥺</span> Who’s behind Dotastatz?</h2>
                <p className="section-body mb-4"> 
                    Dotastatz v1 is designed and developed by <a href="https://tanwanjern.com/" className="">Lester Tan</a>.
                    The first version was completed within 2 months and excluding working days. Therefore, the app still has a long way to go. 
                    <br/>
                    Please forgive me if the app is buggy and don't forget to submit your feedback! Let us improve the app together~
                </p>

                <h2 className="section-title"><span role="img" aria-label="data">🗄️ </span> Data collection</h2>
                <p className="section-body mb-4"> 
                    All of the data provided comes from public sources such as the Steam WebAPI, OpenDota API, Stratz API and Liquipedia API.
                </p>

                <h2 className="section-title">Legal Disclaimer</h2>
                <p className="section-body mb-4">
                    This app was not created, sponsored or endorsed in any way by Valve. All in-game data, descriptions, characters, and imagery of game content are copyright and/or trademarked to their respective owners. This app is intended purely for the love of the game and further skill development and exploration of the game.
                </p>

                <p className="mb-4 mt-5"> 
                    <Link to="/" className="">Back to home</Link>
                </p>
                <Footer textLeft/>
            </div>
        </div>
        
    </main>
  )
}

export default AboutPage
